var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"record-item-wrap"},[(_vm.data.key)?_c('div',{staticClass:"item-title"},[_vm._v(_vm._s(_vm.data.key))]):_vm._e(),_c('div',{class:{
    'item-content': true,
    'little-item':!_vm.data.key && _vm.data.value
  }},[_vm._v(_vm._s(_vm.data.value || _vm.gettext('暂无')))])])}
var staticRenderFns = []

export { render, staticRenderFns }